/** The claims of a JWT (not verified: the server does that), or null when the token is missing or malformed. */
export function jwtClaims(token: string | undefined | null): Record<string, unknown> | null {
  const payload = token?.split('.')[1];
  if (!payload) return null;
  try {
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return null;
  }
}

export const isPlatformToken = (token: string | undefined | null): boolean => jwtClaims(token)?.type === 'platform';
